import { SheetPageBody, SheetPageTitle } from "@/components/ui/sheet-page"
import {
  AlertCircle,
  Check,
  CheckCircle2,
  Mail,
  X,
  XCircle,
} from "lucide-react"
import { useEditProps } from "./page-props"
import { useTranslation } from "react-i18next"
import { Button } from "@/components/ui/button"
import { Alert, AlertDescription } from "@/components/ui/alert"
import { Link } from "@/lib/page-rendering"

export default function Page() {
  const { t } = useTranslation("school_relief_listings", {
    keyPrefix: "applications.edit",
  })
  const { application } = useEditProps()
  const { school_name, relief_listing_title } = application
  return (
    <SheetPageBody>
      <SheetPageTitle icon={Mail}>
        {t("title", { school_name, relief_listing_title })}
      </SheetPageTitle>

      <div className="space-y-6">
        <p className="text-sm">
          {t(`status_description.${application.state}`, {
            relief_listing_title,
            school_name,
          })}
        </p>

        {(application.cancellable || application.acceptable) && (
          <Alert>
            <AlertCircle className="h-4 w-4" />
            <AlertDescription>{t("warning")}</AlertDescription>
          </Alert>
        )}

        <div className="flex gap-3">
          {application.acceptable && (
            <Link
              as={Button}
              method="patch"
              href="."
              data={{ response: "accept" }}
              className="flex-1"
            >
              <Check className="h-4 w-4" />
              {t("accept")}
            </Link>
          )}

          {application.cancellable && (
            <Link
              as={Button}
              method="patch"
              href="."
              data={{ response: "cancel" }}
              className="flex-1"
            >
              <X className="h-4 w-4" />
              {t("cancel")}
            </Link>
          )}
        </div>

        <div className="space-y-3 text-sm">
          {application.acceptable && (
            <div className="flex gap-3">
              <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-green-600" />
              <div>
                <p className="font-medium">{t("accept_info.heading")}</p>
                <p>{t("accept_info.description")}</p>
              </div>
            </div>
          )}

          {application.cancellable && (
            <div className="flex gap-3">
              <XCircle className="mt-0.5 h-5 w-5 shrink-0 text-red-600" />
              <div>
                <p className="font-medium">{t("cancel_info.heading")}</p>
                <p>{t("cancel_info.description")}</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </SheetPageBody>
  )
}
